<template>
    <v-row align="center">
      <v-col cols="12" md="6" lg="8">
        <div class="d-flex align-center pb-0">
          <v-img :max-width="widthLogoSeg" :src="logoSegurify"></v-img>
          <h2 class="ml-5">Pólizas</h2>
        </div>
      </v-col>
    </v-row>
  </template>
  
  <script>
  import logoSegurify from "@/assets/intermx-1.svg";
  export default {
    data() {
      return {
        logoSegurify,
        rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      };
    },
    computed: {
      widthLogoSeg() {
        if (this.$vuetify.breakpoint.smAndDown) return "100";
        if (this.$vuetify.breakpoint.mdAndDown) return "100";
        return "170";
      },
    },
  };
  </script>